// FTEDN Creator — How It Works (animated explainer)
import './HowItWorks.css';

const STEPS = [
  { icon: '📋', title: 'Apply', desc: 'Sign up for an open beta program' },
  { icon: '📦', title: 'Receive', desc: 'Get a product kit shipped to you' },
  { icon: '🧪', title: 'Test', desc: 'Use the product in your routine' },
  { icon: '💬', title: 'Feedback', desc: 'Share your honest thoughts' },
  { icon: '🔬', title: 'Refine', desc: 'We adjust the formula together' },
];

export function HowItWorks() {
  return (
    <div className="how-it-works">
      <h2 className="hiw-title">How the Beta Lab Works</h2>
      <div className="hiw-steps">
        {STEPS.map((step, i) => (
          <div key={i} className="hiw-step" style={{ animationDelay: `${i * 0.1}s` }}>
            <span className="hiw-icon">{step.icon}</span>
            <div className="hiw-connector" />
            <h4>{step.title}</h4>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>
      <p className="hiw-legal">
        By joining a beta program, you agree to the testing agreement and NDA.
        All legal documents are stored securely and accessible at any time.
      </p>
    </div>
  );
}
